import{defineMessages}from'react-intl';

export default defineMessages({
pageTitle:{
id:'i18n.EditEvent.pageTitle',
defaultMessage:'Edit Event'},

brandLabel:{
id:'i18n.EditEvent.brandLabel',
defaultMessage:'Brand'},

descriptionLabel:{
id:'i18n.EditEvent.descriptionLabel',
defaultMessage:'Event Description'},

contactLabel:{
id:'i18n.EditEvent.contactLabel',
defaultMessage:'Brand Contact'},

titleLabel:{
id:'i18n.EditEvent.eventTitle',
defaultMessage:'Event Title'},

goalLabel:{
id:'i18n.EditEvent.goalLabel',
defaultMessage:'Goal'},

prepayRequestLabel:{
id:'i18n.EditEvent.prepayRequestLabel',
defaultMessage:'Prepay Request'},

eventTypeLabel:{
id:'i18n.EditEvent.eventTypeLabel',
defaultMessage:'Event Type'},

dateLabel:{
id:'i18n.EditEvent.DateLabel',
defaultMessage:'Date'},

brandArtistsLabel:{
id:'EditEvent.brandArtistsLabel',
defaultMessage:'Brand Artists'},

appointmentLengthLabel:{
id:'EditEvent.appointmentLengthLabel',
defaultMessage:'Appointment Length'},

viewStockLift:{
id:'i18n.EditEvent.viewStockLift',
defaultMessage:'View Stock Lift'},

addStockLift:{
id:'i18n.EditEvent.addStockLift',
defaultMessage:'Add Stock Lift'},

cancelLabel:{
id:'EditEvent.cancelLabel',
defaultMessage:'CANCEL'},

saveLabel:{
id:'EditEvent.saveLabel',
defaultMessage:'SAVE'},

addNewContactButton:{
id:'i18n.EditEvent.addNewContact',
defaultMessage:'ADD NEW CONTACT'},

deletedEvent:{
id:'i18n.EditEvent.deletedEvent',
defaultMessage:'Delete Event: '}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/components/EditEvent/EditEvent.messages.js
// module id = 2157
// module chunks = 0